import {
  FaHandsHelping,
  FaBullseye,
  FaEye,
  FaShieldAlt,
  FaUsers,
  FaBolt,
  FaCheckCircle,
} from "react-icons/fa";

const About = () => {
  return (
    <div className="about-page">

      {/* ── PAGE HERO ── */}
      <section className="about-hero">
        <div className="about-hero-bg" />
        <div className="container">
          <div className="about-hero-inner">
            <p className="about-eyebrow">Our Story</p>
            <h1>About Our <span>Foundation</span></h1>
            <p className="about-hero-sub">
              Learn more about Geetha Alagappan Foundation and our mission to
              serve humanity with compassion and integrity.
            </p>
          </div>
        </div>
      </section>

      {/* ── INTRO ── */}
      <section className="about-intro">
        <div className="container">
          <div className="about-intro-grid">
            <div className="about-intro-image">
              <img
                src="https://images.unsplash.com/photo-1526256262350-7da7584cf5eb"
                alt="About our foundation"
              />
              <div className="intro-image-card">
                <strong>6+</strong>
                <span>Years of Service</span>
              </div>
            </div>
            <div className="about-intro-text">
              <p className="about-eyebrow">Who We Are</p>
              <h2>A Trust Built on <span>Compassion</span></h2>
              <p>
                Geetha Alagappan Foundation is a charitable trust committed to
                helping individuals and families during times of crisis. Our
                focus is on emergency medical assistance, accident relief, elder
                care, child care, and small livelihood support.
              </p>
              <p>
                We believe compassion can save lives. Even the smallest
                contribution can bring hope, dignity, and healing to someone in
                need.
              </p>
              <ul className="about-checklist">
                {[
                  "Emergency medical funding",
                  "Elder & child welfare",
                  "Accident relief support",
                  "Small livelihood assistance",
                ].map((item) => (
                  <li key={item}>
                    <FaCheckCircle /> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── MISSION & VISION ── */}
      <section className="mv-section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card mv-mission">
              <div className="mv-icon-wrap">
                <FaBullseye />
              </div>
              <h3>Our Mission</h3>
              <p>
                To provide timely financial and emotional support to people
                facing medical emergencies and difficult life situations.
              </p>
            </div>
            <div className="mv-card mv-vision">
              <div className="mv-icon-wrap">
                <FaEye />
              </div>
              <h3>Our Vision</h3>
              <p>
                To build a compassionate society where everyone has access to
                care, dignity, and support in times of need.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="why-section">
        <div className="container">
          <div className="section-header-centered">
            <p className="about-eyebrow">Why Choose Us</p>
            <h2>What Sets Us Apart</h2>
          </div>
          <div className="why-grid">
            {[
              {
                icon: <FaShieldAlt />,
                title: "Transparent & Trusted",
                desc: "We maintain complete transparency in fund collection and distribution.",
              },
              {
                icon: <FaBolt />,
                title: "Fast Emergency Support",
                desc: "We prioritize urgent medical and accident-related cases to save lives quickly.",
              },
              {
                icon: <FaUsers />,
                title: "Community Driven",
                desc: "Our strength comes from donors and volunteers who believe in helping others.",
              },
            ].map(({ icon, title, desc }) => (
              <div className="why-card" key={title}>
                <div className="why-icon-wrap">{icon}</div>
                <h4>{title}</h4>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section className="about-cta">
        <div className="about-cta-decor-1" />
        <div className="about-cta-decor-2" />
        <div className="container">
          <div className="about-cta-inner">
            <div className="about-cta-icon-wrap">
              <FaHandsHelping />
            </div>
            <p className="about-eyebrow light">Join Our Cause</p>
            <h2>Be a Part of Our Mission</h2>
            <p className="cta-main">
              Your support helps us provide emergency medical aid, care for
              elders, support children, and stand with families during
              difficult times.
            </p>
            <p className="cta-sub">
              Together, we can bring hope, dignity, and a better future to
              those who need it the most.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;